import { Answer, Question } from "@/types/questionnaire";
import useTrackEvent from "@/utils/trackEvent";
import { useState } from "react";
import BaseCheckbox from "./BaseCheckbox";
import { Styling } from "@/types/customer";

interface Properties {
    questionnaire: Question,
    completedThemes: {[key: number]: Answer},
    setQuestionCompleted: (completed: boolean) => void,
}

function ThemeComponent(properties: Properties) {
    const trackEvent = useTrackEvent();
    
    const { questionnaire, completedThemes, setQuestionCompleted } = properties;
    const determineCheckedAnswerCount = function(): number {
        let count: number = 0;
        for(const answer of questionnaire.answers) {
            if( answer.checked ) count++;
        }
        return count;
    }
    const [checkedAnswers, setCheckedAnswers] = useState<number>(determineCheckedAnswerCount());
    
    const onClickCheckbox = (answerId: number) => {
        // flip the checked state - NOTE: this alone does not change state, thus does not render
        const answer: Answer = questionnaire.answers[answerId];
        answer.checked = !answer.checked;

        // determine if this question can now be marked as completed
        const newValue: number = checkedAnswers + (answer.checked ? 1 : -1);
        setCheckedAnswers(newValue);
        setQuestionCompleted(newValue > 0);
    }

    return (
        <>
            <div id="themesSection" className="relative flex flex-col w-full gap-5">
                <div id="themesSectionLabel" className="flex-none h-fit w-full flex flex-col">
                    <h3 className="text-white">
                        Selecteer onderwerpen
                    </h3>
                </div>
                <div className="flex-1 h-full">
                    <div className="hidden arrow-left"></div>
                    <div className="flex-1 rounded-lg p-5 bg-white flex flex-col">
                        <h4>{questionnaire.title}</h4>
                        <div className="mt-3 space-y-3 flex-initial">
                            {questionnaire.answers.map((theme: Answer, index: number) => (
                            <label
                                className={`flex-1 flex flex-row p-3 gap-3 bg-white items-center cursor-pointer border-2 rounded-[6px] ${theme.checked ? 'border-[' + Styling.PrimaryColor() + ']' : 'border-[' + Styling.BorderSecondary() + ']'}`}
                                key={theme.id}
                            >
                                <div className="theme-icon-wrapper">
                                    <img src={'/assets/images/' + theme.image + '.svg'} alt={theme.title + ' icon'} className="w-8 h-8" />
                                    { completedThemes[theme.id] ? (
                                        <div className="uv-complete-mark">
                                            <svg viewBox="0 0 13 10">
                                                <use href="#uv-complete-mark"/>
                                            </svg>
                                        </div>
                                    ) : null}
                                </div>
                                <h5 className="flex-1 text-lg font-bold">{theme.title}</h5>
                                <BaseCheckbox 
                                    className="cursor-pointer"
                                    checked={theme.checked}
                                    onChange={() => onClickCheckbox(index)}
                                    onClick={() => trackEvent('Select_Theme', { select: theme.title })}
                                />
                            </label>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ThemeComponent;